export class ApiRequestStatus {
  static LOADING = 'loading'
  static SUCCESS = 'success'
  static ERROR = 'error'

  private readonly state: 'loading' | 'success' | 'error'

  constructor(value) {
    ApiRequestStatus.validateInput(value)
    this.state = value
  }

  get isLoading() {
    return this.state === ApiRequestStatus.LOADING
  }

  get isSuccess() {
    return this.state === ApiRequestStatus.SUCCESS
  }

  get isError() {
    return this.state === ApiRequestStatus.ERROR
  }

  static ofLoading() {
    return new ApiRequestStatus(ApiRequestStatus.LOADING)
  }

  static ofSuccess() {
    return new ApiRequestStatus(ApiRequestStatus.SUCCESS)
  }

  static ofError() {
    return new ApiRequestStatus(ApiRequestStatus.ERROR)
  }

  private static validateInput(value) {
    if (
      ![
        ApiRequestStatus.LOADING,
        ApiRequestStatus.SUCCESS,
        ApiRequestStatus.ERROR
      ].includes(value)
    ) {
      throw new Error(
        '`ApiRequestStatus` must be one of these: LOADING, SUCCESS, ERROR, but not ' +
          value
      )
    }
  }
}
